import { useContext } from "react";
import ConfirmationContext from "./ConfirmationContext";

function useConfirmationDialog() {
    const { confirm, closeDialog } = useContext(ConfirmationContext);
    return [ confirm, closeDialog ];
}

export default useConfirmationDialog;